<template>
  <div>
   
    <br />
     <Menu></Menu>
     <div class="grid-responsive">
          <h1 class="title">Promoções</h1>
 
          <br />      <br />          
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Serviço</th>                    
                  <th>Parceiro</th>                    
                  <th>Observações</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td>{{item.idPromocao}}</td>                  
                  <td>{{item.nomeServico}}</td>                   
                  <td>{{item.nomeParceiro}}</td>                   
                  <td>
                      {{item.observacoes}}
                  </td>  
                </tr>
              </tbody>
            </table>
          </div>
        </div>
    </div>
   
</template>

<style scoped>
tfoot {
  background-color: #fff;
}
#buttonActions {
  margin-top: 30px;
}
</style>

<script>
 

import Menu from "@/components/MenuAdmin.vue";

import {AdminService} from "@/http"


export default {
  name: "servicosAdmin",
  components: {
    Menu,      
  },
  data: () => {
    return {
      items:[],  
      showModal: false,  
    };
  },
  methods: {
    
    visualizarServico(idServico) {
          
        this.$refs["Servico"].visualizarServico(idServico)

    },
    deletarServico(idServico){

       if(!confirm("Deseja deletar?")){
          return false
       }


       AdminService.DeletarServico(idServico).then(response=>{
         
        window.console.warn(response.statusText)
        this.$notify({ group:"notify", text: "Deletado com sucessso",  type:"success", });
        this.servicos()
         

      }).catch(error=>{
          window.console.log(error)
      })

    },
    servicos(){

      AdminService.Promocoes().then(response=>{
       this.items = response.data

      }).catch(error=>{
          window.console.log(error)
      })

    },  
     
  },
  created() {
    this.servicos()
   
  }, 
  watch:{
    //searchServicos: _.debounce(function(text) { this.handlerServicos(text) }, 500),  
  }
};
</script>
 
